import { render, staticRenderFns } from "./CampaignReviewMenu.vue?vue&type=template&id=3bb24618&"
import script from "./CampaignReviewMenu.vue?vue&type=script&lang=js&"
export * from "./CampaignReviewMenu.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReviewMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CampaignReviewMenu.vue"
export default component.exports